import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Small event bus that lets any feature (calculadora, precios, billetera)
 * request the "comprar créditos" modal, which is rendered by LayoutComponent.
 * This avoids prop-drilling the modal trigger through the router outlet.
 */
@Injectable({ providedIn: 'root' })
export class BuyCreditsService {
  private readonly openSubject = new Subject<void>();

  /** Emits whenever a feature asks to open the buy-credits modal. */
  readonly openRequests$: Observable<void> = this.openSubject.asObservable();

  /** Request the buy-credits modal to open. */
  open(): void {
    this.openSubject.next();
  }
}
